import React from "react";
import "./homesection3.css";
import VirtueLogo from "../../../assets/Varlık 1 7.png";
import CodeBlock from "../../../assets/code2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HomeSection3 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="home-section3-container">
      <div className="container">
        <header className="headings">
          <h1>{t("homesection3.heading")}</h1>
          {/* <h2>{t("homesection3.heading2")}</h2> */}
          <h2>{t("homesection3.heading3")}</h2>
        </header>
        {/* <p>{t("homesection3.text")}</p> */}
        <div className="image-container-home">
          <article className="blue-rectangle-content">
            <img
              className="virtue-logo"
              src={VirtueLogo}
              alt="Virtue Logo"
              loading="lazy"
              width="200"
              height="80"
            />

            <div className="blue-rectangle-content-text">
              <h2>{t("homesection3.heading4")}</h2>
              <div className="blue-rectangle-content-text2">
                <p>{t("homesection3.text2")}</p>
                <p>{t("homesection3.text3")}</p>
              </div>
              <Link
                to={`/${lang}/OurServices`}
                onClick={scrollToTop}
                className="cta"
              >
                {t("homesection3.button")}
                <button className="readmore-button">
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    style={{ background: "rgba(0, 0, 0, 0)" }}
                    aria-hidden="true"
                  />
                </button>
              </Link>
            </div>

            <img
              src={CodeBlock}
              className="codeblock"
              alt="Code Block Example"
              loading="lazy"
              width="300"
              height="200"
            />
          </article>
        </div>
      </div>
    </section>
  );
};

export default HomeSection3;
